module.exports = __webpack_public_path__ + "static/media/google_form.125db29c.svg";